module.exports = __webpack_public_path__ + "static/img/labour-7.9427b5b.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/rescuelist/img/list/labour-7.png
// module id = 2/l5
// module chunks = 1